export enum CmsEventTypes {
  LessonStarted = 'lesson_started',
  LessonCompleted = 'lesson_completed',
  QuizStarted = 'quiz_started',
  KickoffQuizStarted = 'quiz_started',
  MasteryQuizStarted = 'quiz_started',
}

export function useCmsEventTracking () {
  const dispatchCmsEvent = async (type: CmsEventTypes, contentId?: string | number) => {
    if (typeof contentId === 'string') {
      contentId = parseInt(contentId);
    }

    const eventData = {
      type,
      contentId,
    };

    const apiUrl = useApiUrl(`/user/event`);

    return await useAuthenticatedFetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(eventData),
    });
  };

  return {
    dispatchCmsEvent,
  };
}